import jsxTemplate from './ErrorTemplate.jsx';
export default function ErrorController() {
  this.jsxTemplate = jsxTemplate;
  const self = this;

  self.init = function init({ err, popup: { close } }) {
    err.date = err.date || new Date();
    self.err = err;
    self.render();
    self.close = close;
    console.error(err);
  };
}
